export default class TenantSimpleModel {
    tenantId: string | null | undefined;
    tenantName: string | null | undefined;
    timezone: string | null | undefined;

    isVNext: boolean | null | undefined;
}